<div class="flex items-start space-x-3 group">
  <!-- Checkbox Input -->
  <div class="relative flex items-center justify-center min-h-11 min-w-11">
    <!-- Hidden native checkbox for accessibility -->
    <input #nativeCheckbox [id]="checkboxId" type="checkbox" class="sr-only" [checked]="checked()" [disabled]="disabled"
      [required]="required" (change)="handleChange($event)" (focus)="onFocus()"
      (blur)="onBlur()" />

    <!-- Custom checkbox -->
    <label [for]="checkboxId" [class]="computedCheckboxClasses()"
      [attr.aria-checked]="indeterminate ? 'mixed' : checked()" [attr.aria-disabled]="disabled" role="checkbox"
      tabindex="0" (keydown)="handleKeyDown($event)">
      <!-- Checkmark icon -->
      @if (checked() && !indeterminate) {
      <div class="absolute inset-0 flex items-center justify-center z-10">
        <ui-icon name="check" [size]="iconSize()"
          customClass="text-primary-600 dark:text-primary-400 drop-shadow-sm animate-glass-fade-in"></ui-icon>
      </div>
      }

      <!-- Indeterminate icon -->
      @if (indeterminate) {
      <div class="absolute inset-0 flex items-center justify-center z-10">
        <ui-icon name="minus" [size]="iconSize()"
          customClass="text-primary-600 dark:text-primary-400 drop-shadow-sm animate-glass-fade-in"></ui-icon>
      </div>
      }

      <!-- Glass shimmer effect -->
      <div
        class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none overflow-hidden rounded-xl">
        <div class="absolute inset-0 bg-linear-to-r from-transparent via-primary-400/20 to-transparent
                        transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                        transition-transform duration-1000 ease-out"></div>
      </div>

      <!-- Premium floating particles -->
      @if (variant === 'premium') {
      <div
        class="absolute inset-0 overflow-hidden pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-700">
        <div class="absolute top-1/4 left-1/4 w-0.5 h-0.5 bg-primary-400/60 rounded-full animate-pulse"></div>
        <div class="absolute top-3/4 right-1/4 w-0.5 h-0.5 bg-white/40 rounded-full animate-pulse delay-500"></div>
        <div class="absolute bottom-1/3 right-1/3 w-0.5 h-0.5 bg-primary-300/50 rounded-full animate-pulse delay-1000">
        </div>
      </div>
      }

      <!-- Checked state glow -->
      @if (checked()) {
      <div class="absolute inset-0 rounded-xl opacity-60 pointer-events-none">
        <div class="absolute inset-0 bg-primary-500/10 rounded-xl animate-glass-pulse"></div>
      </div>
      }
    </label>
  </div>

  <!-- Label and description -->
  @if (label || description) {
  <div class="flex-1 min-w-0">
    @if (label) {
    <label [for]="checkboxId" [class]="computedLabelClasses()">
      {{ label }}
      @if (required) {
      <span class="text-red-500 ml-1">*</span>
      }
    </label>
    } @if (description) {
    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
      {{ description }}
    </p>
    }
  </div>
  }
</div>

<!-- Error message -->
@if (errorMessage) {
<p class="text-sm text-red-600 dark:text-red-400 mt-2 flex items-center">
  <ui-icon name="alert-circle" size="sm" customClass="mr-1 shrink-0"></ui-icon>
  {{ errorMessage }}
</p>
}

<!-- Success message -->
@if (successMessage) {
<p class="text-sm text-cyan-600 dark:text-cyan-400 mt-2 flex items-center">
  <ui-icon name="check" size="sm" customClass="mr-1 shrink-0"></ui-icon>
  {{ successMessage }}
</p>
}